import { render, staticRenderFns } from "./errorServe.vue?vue&type=template&id=119ccf5d&"
import script from "./errorServe.vue?vue&type=script&lang=js&"
export * from "./errorServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports